import React from 'react';
import { Loader } from '@navikt/ds-react';

const Lasteboks = () => (
    <div className="spinner">
        <Loader size="3xlarge" />
    </div>
);

export default Lasteboks;
